enum ContentTypeEnum {
  APPLICATION_JSON = 'application/json',
  APPLICATION_MERGE_PATH_JSON = 'application/merge-patch+json',
}

export default ContentTypeEnum;
